import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Card, CardContent, Typography, Avatar, CardActions, Button, Stack, Tooltip } from '@mui/material';
import { isNotNullOrUndefined } from '@weft/utils';
import React, { useState } from 'react';
import type { IntegrationProviderProperties } from '../integrations-page-types/integration-provider-properties';

export type IntegrationProviderCardProps = IntegrationProviderProperties & {
  name: string;
  connected: boolean;
  onProviderCardClick: () => void;
};

export const IntegrationProviderCard: React.FC<IntegrationProviderCardProps> = ({
  name,
  logo,
  connected,
  onProviderCardClick,
  configurationEnabled,
  integrationType,
  connectionEnabled,
  getConnectionPortal,
  authRedirect,
}) => {
  const [open, setOpen] = useState(false);
  const connectMutation = authRedirect?.();

  const handleConnectButtonClick = async () => {
    setOpen(true);

    if (isNotNullOrUndefined(connectMutation)) {
      await connectMutation.mutateAsync();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          justifyContent: 'space-between',
          border: '1px solid #0D1B271F',
          borderRadius: '10px',
          boxShadow: 'none',
          cursor: connected ? 'pointer' : 'auto',
        }}
        elevation={3}
        onClick={connected && configurationEnabled ? onProviderCardClick : undefined}
      >
        <CardContent
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'start',
            flexDirection: 'column',
            padding: '24px',
          }}
        >
          <Stack
            direction="row"
            spacing={3}
          >
            <Avatar
              alt={name}
              sx={{
                width: 72,
                height: 72,
                border: '1px solid #eee',
                backgroundColor: 'transparent',
              }}
            >
              {logo}
            </Avatar>

            <Typography
              alignSelf="center"
              variant="h6"
              fontWeight={600}
            >
              {name}

              {connected && (
                <Tooltip
                  title={connected ? 'Connected' : undefined}
                  placement="top"
                  arrow
                >
                  <CheckCircleOutlineIcon
                    color="success"
                    sx={{
                      marginLeft: '8px',
                      marginBottom: '4px',
                    }}
                  />
                </Tooltip>
              )}
            </Typography>

          </Stack>

          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="start"
            sx={{ mt: 1 }}
          >
            {`Connect and Manage ${integrationType} application connection.`}
          </Typography>
        </CardContent>
        <CardActions
          sx={{
            justifyContent: 'end',
            padding: '24px',
            backgroundColor: '#F7F7F7',
            width: '100%',
            borderTop: '1px solid #0D1B271F',
          }}
        >
          <Button
            size="small"
            variant="text"
            color="primary"
            sx={{
              backgroundColor: 'white',
              color: 'black',
            }}
            onClick={handleConnectButtonClick}
            disabled={!connectionEnabled}
          >
            View Integration
          </Button>
        </CardActions>
      </Card>
      {isNotNullOrUndefined(getConnectionPortal) ? getConnectionPortal(open, handleClose) : null}
    </>
  );
};